import {PaymentCardReaderSummaryModel} from "./paymentCardReaderSummary.model";
import {IWithSummaryModel} from "../../../../../../common/permission/api/entity/iWithSummary.model";
import {ValueAndLabelModel} from "../../../../../../common/model/valueAndLabel.model";

export class PaymentCardReaderModel implements IWithSummaryModel<PaymentCardReaderSummaryModel> {
    summary: PaymentCardReaderSummaryModel;
    status: ValueAndLabelModel;
}
